/**
 * Универсальный «парсер» ошибок axios → диспатч в стор.
 *
 * Контракт `errorAction` — по числу параметров:
 *   - `(errorMessage)` — получаешь строку с уже извлечённым текстом.
 *   - `(errorMessage, isNetworkError, statusCode)` — позиционно, для
 *     слайсов, которые хранят флаг сети / код статуса отдельными полями.
 *
 * Раньше при `length > 1` вызов делался одним объектом
 * (`errorAction(errorData)`), и слайсы вида
 * `(errorMessage, isNetworkError) => dispatch(setError({errorMessage, isNetworkError}))`
 * ловили в `errorMessage` весь объект (`{errorMessage, isNetworkError, statusCode}`)
 * и записывали его в `state.error`. Затем UI пытался отрендерить объект
 * как ReactNode → «Objects are not valid as a React child».
 */
export function handleResponseError(error, errorAction) {
    let errors;
    let message = '';
    let isNetworkError = false; // Флаг для сетевой ошибки
    let statusCode = error.response?.status || null; // Код ответа сервера

    if (error.response) {
        errors = error.response.data?.errors;

        if (errors) {
            message = Object.values(errors).flat().join('\n');
        } else if (error.response.data?.error) { // 🛠 Берём `error` из ответа сервера
            message = error.response.data.error;
        } else if (error.response.data?.message) {
            message = error.response.data.message;
        } else {
            message = error.message || 'An error occurred.';
        }
    } else if (error.request) {
        // Обработка случаев с отсутствием ответа от сервера (например, сеть недоступна)
        message = `${error.message}. Please try later or reload the page.`;
        isNetworkError = true;
    } else {
        // Обработка всех других ошибок
        message = error.message || 'An error occurred.';
    }

    console.error(`Error (${statusCode}):`, message);

    if (errorAction.length <= 1) {
        errorAction(message);
    } else {
        errorAction(message, isNetworkError, statusCode);
    }
}
